import withNoindex from "../components/seo/with-noindex"

export default withNoindex(require("../templates/ResetPasswordFirstStep").default, "Esqueci minha senha")
